import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { BikePremiumCalculationService } from '@base/app/features/calculator-overview/services/bike-premium-calculation.service';
import { BikeCalculatorFormModel, createBikeCalculatorForm } from '../../factories/bike-calculator-form.factory';
import { BikeService } from '../../services/bike.service';
import { ServoBikeProductType } from '@base/backend';
import { debounceTime, filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-bike-calculator',
  standalone: true,
  imports: [
    PaginatorModule,
    ReactiveFormsModule,
    CurrencyPipe
  ],
  providers: [BikePremiumCalculationService],
  templateUrl: './bike-calculator.component.html',
  styleUrl: './bike-calculator.component.scss'
})
export class BikeCalculatorComponent implements OnInit {
  private readonly bikeService = inject(BikeService);

  @Output() requestOffer = new EventEmitter<{ isEbike: boolean, price: number, premium: number, bikeProductType: null }>();

  form!: FormGroup<BikeCalculatorFormModel>;

  premium: number | null = null;

  ngOnInit() {
    this.form = createBikeCalculatorForm();

    this.form.valueChanges.pipe(
      debounceTime(300),
      filter(value =>
        value.price !== null &&
        value.price !== undefined &&
        value.isEbike !== null &&
        value.isEbike !== undefined
      ),
      switchMap(value => {
        return this.bikeService.getPremium(
          value.price!,
          value.isEbike!,
          ServoBikeProductType.StandardBikeEbike
        );
      })
    ).subscribe(premium => {
      this.premium = premium;
    });
  }

  submit(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid || this.premium === null) {
      return;
    }

    this.requestOffer.emit({
      price: this.form.getRawValue().price!,
      isEbike: this.form.getRawValue().isEbike!,
      premium: this.premium,
      bikeProductType: null
    });
  }
}
